import { Container, CssBaseline, Skeleton, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import packages from '../../../services/package'
import { ErrorPage, Header, PackageCard } from '../../../components'

export default function Packages() {
  const {
    data: queryPackages,
    isLoading,
    isError,
  } = useQuery({
    queryFn: () => packages.get(),
    queryKey: ['packages'],
  })

  if (isError)
    return (
      <>
        <Header />
        <ErrorPage
          text={`Encontramos um erro ao buscar os pacotes! Por favor, recarregue a página.`}
        />
      </>
    )

  return (
    <Container component="main">
      <CssBaseline />
      <Header>
        <Typography sx={{ fontSize: '1.3rem', fontWeight: '700' }}>
          Pacotes disponíveis
        </Typography>
        <div />
      </Header>

      {!isLoading ? (
        queryPackages?.map((localPackage) => (
          <PackageCard key={localPackage.id} data={localPackage} />
        ))
      ) : (
        <>
          <Skeleton
            variant="rounded"
            sx={{ width: '100%', height: 240, mb: 2 }}
          />
          <Skeleton variant="rounded" sx={{ width: '100%', height: 240 }} />
        </>
      )}

      <div className="flex flex-col items-center absolute bottom-3 right-0 left-0">
        <img src="/security-checked.svg" className="w-24" alt="security icon" />
        <p className="text-disabled text-center w-[70%]">
          Sistema de pagamentos com Segurança verificada!
        </p>
      </div>
    </Container>
  )
}
